// extracted by mini-css-extract-plugin
export default {"status":"ErrorRecoveryDemoVoice_status__luNUG","replies":"ErrorRecoveryDemoVoice_replies__eVDmn","home":"ErrorRecoveryDemoVoice_home__7khp2"};